// PLACEHOLDER flag names. Confirm the real Atlas feature flag(s) with the Atlas
// owner, then replace the values below. The gate matches if the user has ANY of
// these flags.
export const DATA_IMPORT_FEATURE_FLAGS = [
  'PFaroePM-DataImport-Dev',
  'PFaroePM-DataImport-Test',
  'PFaroePM-DataImport-Prod',
];
